import styled from 'styled-components';

export const StyledRatingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1px;
`;
